module.exports = __webpack_public_path__ + "static/media/GCP_contentsPage_en.6b06fd1c.png";